export const ItemTypes = {
  CARD: 'card',
  LOOKAHEAD_ORDER_COL: 'lookahead_order_col'
};
